import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// react-snap prerendering compatibility:
// If the page was pre-rendered by react-snap, hydrate it instead of re-rendering from scratch.
// This preserves the pre-rendered HTML for SEO crawlers while React takes over on the client.
const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
